import axios from 'axios';

// Axios instance using environment variable for the base URL
export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Error handler
const handleApiError = (error) => {
  if (error.response) {
    console.error('API Response Error:', error);
    return { error: error };
  } else if (error.request) {
    console.error('API Request Error:', error.request);
    return { error: 'No response from server. Please try again later.' };
  } else {
    console.error('Error:', error.message);
    return { error: error.message };
  }
};

// CRUD Operations for Blocks

export const createBlock = async (data) => {
  try {
    const response = await api.post('/Blocks', data);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const fetchBlocks = async () => {
  try {
    const response = await api.get('/Blocks');
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const fetchBlockById = async (id) => {
  try {
    const response = await api.get(`/Blocks/${id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateBlock = async (id, data) => {
  try {
    const response = await api.put(`/Blocks/${id}`, data);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteBlock = async (id) => {
  try {
    const response = await api.delete(`/Blocks/${id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// CRUD Operations for Categories

export const createCategory = async (data) => {
  try {
    const response = await api.post('/Categories', data);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const fetchCategories = async () => {
  try {
    const response = await api.get('/Categories');
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const fetchCategoryById = async (id) => {
  try {
    const response = await api.get(`/Categories/${id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateCategory = async (id, data) => {
  try {
    const response = await api.put(`/Categories/${id}`, data);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteCategory = async (id) => {
  try {
    const response = await api.delete(`/Categories/${id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// CRUD Operations for HouseDetails

export const createHouseDetail = async (data) => {
  try {
    const response = await api.post('/HouseDetails', data);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const fetchHouseDetails = async () => {
  try {
    const response = await api.get('/HouseDetails');
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const fetchHouseDetailById = async (id) => {
  try {
    const response = await api.get(`/HouseDetails/${id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateHouseDetail = async (id, data) => {
  try {
    const response = await api.put(`/HouseDetails/${id}`, data);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteHouseDetail = async (id) => {
  try {
    const response = await api.delete(`/HouseDetails/${id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// CRUD Operations for HouseStatus

export const createHouseStatus = async (data) => {
  try {
    const response = await api.post('/HouseStatus', data);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const fetchHouseStatuses = async () => {
  try {
    const response = await api.get('/HouseStatus');
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const fetchHouseStatusById = async (id) => {
  try {
    const response = await api.get(`/HouseStatus/${id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateHouseStatus = async (id, data) => {
  try {
    const response = await api.put(`/HouseStatus/${id}`, data);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteHouseStatus = async (id) => {
  try {
    const response = await api.delete(`/HouseStatus/${id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// CRUD Operations for Panchayats

export const createPanchayat = async (data) => {
  try {
    const response = await api.post('/Panchayats', data);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const fetchPanchayats = async () => {
  try {
    const response = await api.get('/Panchayats');
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const fetchPanchayatById = async (id) => {
  try {
    const response = await api.get(`/Panchayats/${id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const updatePanchayat = async (id, data) => {
  try {
    const response = await api.put(`/Panchayats/${id}`, data);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const deletePanchayat = async (id) => {
  try {
    const response = await api.delete(`/Panchayats/${id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// CRUD Operations for TransactionImages

export const createTransactionImage = async (data) => {
  try {
    const response = await api.post('/TransactionImages', data);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const fetchTransactionImages = async () => {
  try {
    const response = await api.get('/TransactionImages');
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const fetchTransactionImageById = async (id) => {
  try {
    const response = await api.get(`/TransactionImages/${id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateTransactionImage = async (id, data) => {
  try {
    const response = await api.put(`/TransactionImages/${id}`, data);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteTransactionImage = async (id) => {
  try {
    const response = await api.delete(`/TransactionImages/${id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// CRUD Operations for Transactions

export const createTransaction = async (data) => {
  try {
    const response = await api.post('/Transactions', data);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const fetchTransactions = async () => {
  try {
    const response = await api.get('/Transactions');
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const fetchTransactionById = async (id) => {
  try {
    const response = await api.get(`/Transactions/${id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const fetchTransactionDetailsById = async (id) => {
  try {
    const response = await api.get(`/Transactions/TransactionDetails/${id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateTransaction = async (id, data) => {
  try {
    const response = await api.put(`/Transactions/${id}`, data);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};
export const fetchReportData = async (params) => {
  try {
    const response = await api.get('/Transactions/Filter', { params });
    return response.data; 
  } catch (error) {
    return handleApiError(error); 
  }
};




export const deleteTransaction = async (id) => {
  try {
    const response = await api.delete(`/Transactions/${id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// CRUD Operations for Users

export const createUser = async (data) => {
  try {
    const response = await api.post('/Users', data);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const fetchUsers = async () => {
  try {
    const response = await api.get('/Users');
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const fetchUserById = async (id) => {
  try {
    const response = await api.get(`/Users/UserProfile/${id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateUser = async (id, data) => {
  try {
    const response = await api.put(`/Users/${id}`, data);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteUser = async (id) => {
  try {
    const response = await api.delete(`/Users/${id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// CRUD Operations for Villages

export const createVillage = async (data) => {
  try {
    const response = await api.post('/Villages', data);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const fetchVillages = async () => {
  try {
    const response = await api.get('/Villages');
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const fetchVillageById = async (id) => {
  try {
    const response = await api.get(`/Villages/${id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateVillage = async (id, data) => {
  try {
    const response = await api.put(`/Villages/${id}`, data);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteVillage = async (id) => {
  try {
    const response = await api.delete(`/Villages/${id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// CRUD Operations for Years

export const createYear = async (data) => {
  try {
    const response = await api.post('/Years', data);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const fetchYears = async () => {
  try {
    const response = await api.get('/Years');
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const fetchYearById = async (id) => {
  try {
    const response = await api.get(`/Years/${id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateYear = async (id, data) => {
  try {
    const response = await api.put(`/Years/${id}`, data);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteYear = async (id) => {
  try {
    const response = await api.delete(`/Years/${id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};


// CRUD Operations for Report
export const fetchStatistics = async () => {
  try {
    const response = await api.get('/Transactions/Statistics');
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};


// CRUD Operations for Schemes
export const createSchemes = async (data) => {
  try {
    const response = await api.post('/Schemes', data);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const fetchSchemesData = async () => {
  try{
    const response = await api.get('/Schemes');
    return response;
  }
  catch (error) {
    return handleApiError(error);
  }
}
export const fetchSchemesById = async (id) => {
  try {
    const response = await api.get(`/Schemes/${id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};
export const updateSchemes= async (id, data) => {
  try {
    const response = await api.put(`/Schemes/${id}`, data);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteSchemes= async (id) => {
  try {
    const response = await api.delete(`/Schemes/${id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// CRUD Operations for Districts
export const createDistricts = async (data) => {
  try {
    const response = await api.post('/Districts', data);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const fetchDistrictsData = async () => {
  try{
    const response = await api.get('/Districts');
    return response;
  }
  catch (error) {
    return handleApiError(error);
  }
}
export const fetchDistrictsById = async (id) => {
  try {
    const response = await api.get(`/Districts/${id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};
export const updateDistricts= async (id, data) => {
  try {
    const response = await api.put(`/Districts/${id}`, data);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteDistricts= async (id) => {
  try {
    const response = await api.delete(`/Districts/${id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// CRUD Operations for BlockEmails

export const createBlockEmails = async (data) => {
  try {
    const response = await api.post('/BlockEmails', data);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const fetchBlockEmails = async () => {
  try {
    const response = await api.get('/BlockEmails');
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const fetchBlockEmailsById = async (id) => {
  try {
    const response = await api.get(`/BlockEmails/${id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateBlockEmails = async (id, data) => {
  try {
    const response = await api.put(`/BlockEmails/${id}`, data);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteBlockEmails = async (id) => {
  try {
    const response = await api.delete(`/BlockEmails/${id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};